import styled from "styled-components";

export const ApplicationsPageContainer = styled.div`
    width: 100%;
    height: 100%;

    box-sizing: border-box;
    padding: 20px;
    padding-bottom: 0;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    background-color: var(--color-primary);
`;
